/**
 * A flight cell, e.g. "TK - 761", "G9-321" or "SQ 495" — the separator is whatever the editor
 * typed. "TBA" matches nothing, which is correct: an unconfirmed sector has no carrier yet, and
 * neither does a date, a time or an airport code, so this is safe to run over a whole row.
 */
const FLIGHT_NUMBER = /^([A-Z][A-Z0-9])\s*-?\s*\d+$/i

/** The IATA carrier code a flight number starts with, or `undefined` when the cell is not one. */
export function getCarrierCode(cell: string): string | undefined {
    const match = FLIGHT_NUMBER.exec(cell.trim())
    return match ? match[1].toUpperCase() : undefined
}
